export default "assets/images/flags/es-b2ec5bf9.svg";